if (!customElements.get('lc-wellness')) {
  customElements.define('lc-wellness', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[data-tab-panel]')];
      const selectTab = index => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
      };
      if (tabs.length && tabs.length === panels.length) {
        this.querySelector('[data-tab-buttons]').hidden = false;
        panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabs[index].id);
          panel.tabIndex = 0;
        });
        selectTab(0);
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => selectTab(index), options);
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault(); selectTab(next); tabs[next].focus();
          }, options);
        });
      }
      this.querySelectorAll('[data-open-ingredients]').forEach(link => {
        link.addEventListener('click', event => {
          const target = document.getElementById(link.hash.slice(1));
          if (!target || !this.contains(target)) return;
          event.preventDefault(); target.open = true;
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          target.querySelector('summary')?.focus({ preventScroll: true });
        }, options);
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
